import React, {lazy, Suspense, useState} from "react";
import "./Banner.css";
import {Button} from "@mui/material";
import UserService from "../../services/UserService";
import GoogleAnalytics from "../../analytics/GoogleAnalytics";
import AwsApiService from "../../services/AwsApiService";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import EnterCoupon from "../EnterCoupon/EnterCoupon";
import CmsHelper, {LandingPageHelper} from "../Utilities/CmsHelpers";
import PopUp from "../Utilities/PopUp";
// import contest from "../Contest/Contest";
import CheckBox from "../Account/components/CheckBox/CheckBox";
import {useCms} from "../../context/CmsContext";
import {useAuth} from "../../context/AuthContext";
import {useTranslation} from "react-i18next";
import useTheme from "../../Themes/ThemeProvider.ts";

const Markdown = lazy(() => import("react-markdown"));

function Banner({avod = false,
                    hasSubscription = false,
                    productName = "",
                    onGoToProducts,
                    bannerData,
                    isContest,
                    accountResolved = true}) {
    const { t } = useTranslation();


    const { setCheckLoggedIn,loggedIn  } = useAuth();


    const {renderingType} = useCms();

    const theme = useTheme();

    const [termsPopUp, setTermsPopUp] = useState(false);

    const onRegister = (redirectURI) => {
        GoogleAnalytics.onRegister();
        AwsApiService.onRegister();
        UserService.doRegister(redirectURI);
    };

    const onTryFreeTrial = () => {
        window.open(`${process.env.REACT_APP_HOMEPAGE_AVOD_BUTTON_LINK}`, "_self");
    };

    const onStart = () => {
        setCheckLoggedIn(false);
        window.open(`${process.env.REACT_APP_CONGRATS_BUTTON_LINK}`, "_self");
    };

    const handleContestSubmit = ()=>{
        if(termsAndConditions){
            setCheckLoggedIn(false);
            sessionStorage.setItem("contestSession", bannerData.identifier)
            sessionStorage.setItem("contestRedirectURL", bannerData.redirectURL)
            if (!loggedIn) {
                onRegister(process.env.REACT_APP_PICKPROGRAM_URL);
            } else {
                window.open(process.env.REACT_APP_PICKPROGRAM_URL, "_self")
            }
        }else{
            setTermsAndConditionsError(true);
        }
    }

    const price = isContest ? undefined : LandingPageHelper.getBannerPricing(bannerData.price, productName);
    const onHeroButtonClick = (e) => {
        e.preventDefault();
        if (bannerData.redirectURL && bannerData.target_dsp_n?.data) {
            setCheckLoggedIn(false);
            sessionStorage.setItem("promoRedirectURL", bannerData.redirectURL)
            sessionStorage.setItem("promoTargetDisplayName", JSON.stringify(bannerData.target_dsp_n?.data.map(names => names.attributes.value)))
            if (!loggedIn) {
                onRegister(process.env.REACT_APP_PICKPROGRAM_URL);
            } else {
                window.open(process.env.REACT_APP_PICKPROGRAM_URL, "_self")
            }
        } else {
            if (!loggedIn) {
                onRegister(process.env.REACT_APP_REGISTER_REDIRECT_URI);
            } else if (avod) {
                onTryFreeTrial();
            } else if (hasSubscription) {
                onStart();
            }
        }
    };
    const [termsAndConditions, setTermsAndConditions] = useState(false);
    const [termsAndConditionsError, setTermsAndConditionsError] = useState(false);

    const heroImage = CmsHelper.getImageAttributes(CmsHelper.getImageData(bannerData?.images, renderingType));
    const heroImagePath = heroImage?.url;

    return (<div id="banner">
            {heroImagePath &&
                <div id="banner-media">
                    <img src={heroImagePath}
                         alt=""
                         fetchpriority="high"
                         decoding="async"
                         width={heroImage?.width}
                         height={heroImage?.height}/>
                </div>
            }
            {(bannerData && bannerData.id) &&
                <>
                  <div id="banner-wrapper">
                    <div id="main-section" className={`${isContest ? "bannerContest": ""}`}>
                      <div className={`info ${isContest ? "bannerContest": ""}`}>
                        <h1 className={`${isContest ? "bannerContest": ""}`}>{bannerData.title}</h1>
                        {CmsHelper.getDetails(bannerData.details).map((item, index) => {
                          return <p key={index}>{item}</p>
                        })}
                      </div>
                      <div className="price-and-actions">
                          {!isContest &&
                              <p className={accountResolved ? "" : "awaiting-account"}>
                                  <span>{price?.priceDescr}</span> {price?.price}
                              </p>
                          }

                          <div className={`buttons ${accountResolved ? "" : "awaiting-account"}`}>
                              <Button variant="contained"
                                      color="primary"
                                      onClick={isContest ? handleContestSubmit : onHeroButtonClick}
                                      id="banner-register-button">
                                {isContest ? t("contestPrimaryBtn"):price?.primary_btn}
                              </Button>
                              {(!isContest && price?.secondary_btn) &&
                                  <Button variant="outlined"
                                          color="primary"
                                          onClick={() => onGoToProducts?.()}
                                          id="check-products"
                                          endIcon={<ArrowDownwardIcon id="arrow-icon"/>}>
                                    {price?.secondary_btn}
                                  </Button>}
                          </div>

                          {isContest ?
                              <CheckBox disabled={false}
                                        action={()=>{setTermsAndConditions((prevState)=>!prevState);setTermsAndConditionsError(false)}}
                                        checked={termsAndConditions}
                                        text={<div className={`terms-and-conditions ${termsAndConditionsError ? "contestError": ""}`}>
                                            <span>{t("ReadAndAgreedTerms")}{" "}</span>
                                            <Button variant="text" onClick={() => setTermsPopUp(true)}>
                                                {t("termsCTA")}
                                            </Button>
                                        </div>}/>
                              :
                              <div className="terms-and-conditions">
                                  {t("termsStar")}{" "}
                                  <a href={theme.uris.other.termsAndConditions}>
                                      {t("readTerms")}
                                  </a>
                              </div>
                          }
                      </div>
                    </div>
                  </div>
                    {!isContest &&
                      <div id="coupon-wrapper">
                        <EnterCoupon/>
                      </div>
                    }
                  <PopUp openPopUp={termsPopUp}
                         setOpenPopUp={setTermsPopUp}
                         maxWidth="md"
                         showCloseButton={true}
                         title={t("termsPopupTitle")}>
                      {isContest ?
                          <div className="terms-and-conditions-wrapper">
                              <Suspense fallback={null}><Markdown>{bannerData.termsAndConditions}</Markdown></Suspense>
                          </div>
                          :<></>
                      }
                  </PopUp>
                </>}
    </div>);
}

export default Banner;
